import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const get = (path, config) => axios.get(`${API}${path}`, config).then((r) => r.data);

export const api = {
  settings: () => get('/settings'),
  stats: () => get('/stats'),
  about: () => get('/about'),
  tournaments: (status) =>
    get('/tournaments', status && status !== 'all' ? { params: { status } } : undefined),
  featured: () => get('/tournaments/featured'),
  streams: () => get('/streams'),
  faqs: () => get('/faqs'),
  policy: (slug) => get(`/policy/${slug}`),
  collaborators: () => get('/collaborators'),
  hosts: () => get('/hosts'),
  sendEnquiry: (payload) => axios.post(`${API}/enquiry`, payload).then((r) => r.data),
};

export const bannerSrc = (url) => {
  if (!url) return '';
  if (url.startsWith('/api/')) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};

export function formatIST(dt) {
  if (!dt) return '';
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return '';
  return (
    d.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: 'numeric',
      month: 'short',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }) + ' IST'
  );
}
